<template>
  <div class="factoring-build-project-container">
    <div class="table-title">
      <div class="title-left">
        <i class="el-icon-s-management" />项目信息
      </div>
      <div class="title-right"></div>
    </div>

    <!-- 业务列表 -->
    <div class="list-content">
      <template v-for="(item, index) in listConfig">
        <div class="info-one" :key="`${item.prop}-${index}`">
          <div class="info-left">{{item.label}}</div>
          <div class="info-right">{{listData[item.prop]?listData[item.prop]:'无'}}</div>
        </div>
      </template>
    </div>

    <div class="list-content" style="margin-top: 0.4rem">
      <template v-for="(item, i) in extraFormConfig">
        <div class="info-one" :key="`${item.prop}-${i}`">
          <div class="info-left">{{item.label}}</div>
          <div class="info-right">{{listData[item.prop]?listData[item.prop]:'无'}}</div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: "FactoringBuildProjectInfo",
  data() {
    return {
      listConfig: [
        {
          label: '项目名称',
          prop: 'name',
        },{
          label: '保理类型',
          prop: 'projectTypeStr',
        },{
          label: '卖方（债权人）',
          prop: 'sellerCustName',
        },{
          label: '买方（债务人）',
          prop: 'buyerCustName',
        },{
          label: '项目来源',
          prop: 'projectComeFromStr',
        },{
          label: '担保方式',
          prop: 'guaranteeMethod',
        },{
          label: '还款方式',
          prop: 'repaymentTypeStr',
        },{
          label: '报价方案',
          prop: 'quotaPlanName',
        },{
          label: '特别操作说明',
          prop: 'remarks',
        }
      ],
      extraFormConfig: [
        {
          label: '项目编号',
          prop: 'number',
        },{
          label: '所属部门',
          prop: 'managerDeptName',
        },{
          label: '业务主办',
          prop: 'managerUserName',
        },{
          label: '业务协办',
          prop: 'assistUserName',
        },{
          label: '保理额度',
          prop: 'factoringCreditStr',
        },{
          label: '保理融资期限',
          prop: 'financingMaturity',
        },{
          label: '保理首付款使用费率',
          prop: 'annualInterestRateStr',
        },{
          label: '内部收益率',
          prop: 'xirrStr',
        },{
          label: '逾期使用费率',
          prop: 'overdueInterestRateStr',
        },{
          label: '手续费',
          prop: 'poundageStr',
        },{
          label: '手续费收取方式',
          prop: 'poundageChargeTypeStr',
        },{
          label: '保证金',
          prop: 'cashDepositStr',
        },{
          label: '保证金收取方式',
          prop: 'cashDepositChargeTypeStr',
        },{
          label: '保证金归还方式',
          prop: 'cashDepositReturnTypeStr',
        },{
          label: '宽限期',
          prop: 'gracePeriod',
        },{
          label: '宽限期费率',
          prop: 'graceRateStr',
        }
      ]
    }
  },
  props: {
    listData: {
      type: Array,
      default: () => {
        return {}
      }
    }
  }  
}
</script>
<style lang="scss" scoped>
.factoring-build-project-container{
  .table-title{
    width: 100%;
    height: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1rem;
    margin-top: .2rem;
    padding-left: .3rem;
    padding-right: .3rem;
    .title-left{
      font-size: .38rem;
      color: #666;
      font-weight: 600;
    }
    .title-right{
      font-size: .38rem;
      color: #ccc;
    }
  }
  .index-title{
    height: 1rem;
    background-color: #fff;
    line-height: 1rem;
    position: relative;
    text-indent: .3rem;
  }
  .index-title::before{
    position: absolute;
    left: 0;
    top: 0;
    width: 0.1rem;
    height: 1rem;
    content: '';
    background-color: #409eff;
  }
  .list-content{
    .info-one{
      background-color: #fff;
      border-top:  .5px solid #f2f2f2;
      border-bottom:  .5px solid #f2f2f2;
      padding-left: .3rem;
      padding-right: .3rem;      
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 1.2rem;
      padding-top: 0.15rem;
      padding-bottom: 0.15rem;
      .info-left{
        width: 36%;
        color: #999;
        font-size: .38rem;
      }
      .info-right{
        width: 65%;
        font-size: .38rem;
        text-align: right;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
      }
    }
  }
  .item-one{
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    width: 100%;
    padding: .35rem .4rem;
    border-radius: .2rem;
    margin-bottom: .2rem;
    .item-index{
      font-size: .38rem;
      line-height: .7rem;
      color: #999;
      font-weight: 600;
    }
    .item-line{
      font-size: .38rem;
      line-height: .55rem;
      color: #999;
      span{
        margin-left: .3rem;
      }
    }
    .remark-content{
      font-size: .38rem;
      color: #333;
      line-height: .7rem;
    }
  }
}
</style>